// Validates contract-preparation metadata but keeps it invisible because its
// child ledger cannot pair with parent-ledger completion.
import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const subagentInitPayloadSchema = z
    .object({
        type: z.literal('subagent_init'),
        parent_run_id: z.uuid(),
        sub_agent_id: z.uuid(),
        objective: z.string(),
    })
    .strip();

export const subagentInitDefinitions = {
    subagent_init: defineInvisible('subagent_init', {
        disposition: 'invisible',
        schema: subagentInitPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const subagentInitContractFixtures = {
    valid: {
        type: 'subagent_init',
        parent_run_id: '0198a846-739e-7a2f-a152-66a77cc11111',
        sub_agent_id: '0198a846-739e-7a2f-a152-66a77cc22222',
        objective: 'Inspect the account history.',
    },
    malformed: {
        type: 'subagent_init',
        parent_run_id: 'not-a-uuid',
        sub_agent_id: '0198a846-739e-7a2f-a152-66a77cc22222',
        objective: 'Inspect the account history.',
    },
} as const;
